import sanitize from "sanitize-html";

const isValidFAQItems = (items) => Array.isArray(items) && items.length > 0;

/**
 * Evaluates whether the FAQ parameter is valid or not.
 * @param {Object}
 * @return {boolean}
 */
export const isValidFAQData = (faq) =>
  !!faq && !!faq.title && isValidFAQItems(faq.items);

export const buildFAQMetadata = (faq) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      faq.map((faqItem) => ({
        "@type": "Question",
        name: sanitize(faqItem.question),
        acceptedAnswer: {
          "@type": "Answer",
          text: sanitize(faqItem.answer),
        },
      })),
    ],
  };
};
